<template>
  <base-section id="committee">
    <v-container>
    <base-section-heading
    title="Organizing Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
    <v-col
      cols="12"
      md="6"
    >
    <strong>General Co-Chairs<br /></strong>
    Ernesto Sanchez - Politecnico di Torino, Italy<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Vice-General Chair<br /></strong>
    Wilson Javier Perez H. - UPTC, Colombia<br />
    <strong>Local Chair</strong><br>
    Felipe Restrepo - UNAL, Colombia<br />
    <br /><strong>Past General Co-Chairs<br /></strong>
    Leticia Bolzani Pöhls - IHP - Leibniz Institute for High Performance Microelectronics, Germany<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Program Co-Chairs<br /></strong>
    Leticia Bolzani Pöhls - IHP - Leibniz Institute for High Performance Microelectronics, Germany<br />
    Tiago Balen - UFRGS, Brazil<br />
    <br /><strong>Vice-Program Chair<br /></strong>
    Cristina Meinhardt - UFSC, Brazil<br />
    <br /><strong>Publication Chair<br /></strong>
    Thiago S. Copetti - RWTH Aachen University, Germany<br />
    <br /><strong>Embedded Tutorial Chair</strong><br />
    Riccardo Cantoro - Politecnico di Torino, Italy<br />
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
    <br /><strong>Special Session Co-Chairs</strong><br />
    Florence Azais, LIRMM - France<br />
    Graziano Pravadeli - University of Verona, Italy<br />
    Fabian Luis Vargas - IHP, Germany<br />
    Annachiara Ruospo - Politecnico di Torino, Italy<br />
    <br /><strong>Publicity Chair<br /></strong>
    Nicolo' Bellarmino - Politecnico di Torino, Italy<br />
    <br /><strong>Web and communications Chair<br /></strong>
    Giusy Iaria - Politecnico di Torino, Italy<br />
    <br /><strong>Industry Relations Chair<br /></strong>
    Paolo Bernardi - Politecnico di Torino, Italy<br />
    <br /><strong>LA Liaison</strong><br />
    Victor Champac - INAOE, Mexico<br />
    <br /><strong>European Liaison<br /></strong>
    Hans-Joachim Wunderlich - University of Stuttgart, Germany<br />
    Sybille Hellebrand – Univ. Paderborn, Germany<br />
    <br /><strong>USA Liaison<br /></strong>
    Abhijt Chatterjee - Georgia Tech, USA<br />
    <br /><strong>Asian Liaison<br /></strong>
    Stefan Holst - Kyushu Institute of Technology, Japan<br />
    </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Steering Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in steerings"
        :key="i"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }} - <i>{{ program.text }}</i>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Program Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in programs"
        :key="i"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }} - <i>{{ program.text }}</i>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Committee',

    data: () => ({
      steerings: [
          {
          text: "INAOE, Mexico",
          title: "Victor Champac",
          },
          {
          text: "UFRGS, Brazil",
          title: "Marcelo Lubazewski ",
          },
          {
          text: "IHP GmbH, Germany",
          title: "Fabian Vargas",
          },
          {
          text: "TIMA, France",
          title: "Raoul Velazco",
          },
          {
          text: "Synopsys, USA",
          title: "Yervant Zorian",
          },
          {
          text: "UFRGS, Brazil",
          title: "Tiago Balen",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Ernesto Sanchez",
          },
          {
          text: "RWTH Aachen University, Germany",
          title: "Leticia M. Bolzani Pöhls",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Matteo Sonza Reorda",
          },
      ],
      programs: [
          {
          text: "Politecnico di Torino",
          title: "Ernesto Sanchez",
          },
          {
            text: "Grenoble INP - TIMA Laboratory",
            title: "Mounir Benabdenbi",
          },
          {
            text: "Centro Atómico Bariloche - CNEA / CONICET",
            title: "Jose Lipovetzky",
          },
          {
          text: "University of California San Diego",
          title: "Alex Orailoglu",
          },
          {
          text: "RWTH",
          title: "Thiago Santos Copetti",
          },
          {
          text: "Sorbonne Université, CNRS, LIP6",
          title: "Haralampos-G. Stratigopoulos",
          },
          {
          text: "University of Applied Sciences Nordhausen",
          title: "Mario Schölzel",
          },
          {
          text: "Politecnico di Milano",
          title: "Antonio Miele",
          },
          {
          text: "University of Paderborn",
          title: "Sybille Hellbrand",
          },
          {
          text: "Testonica Lab",
          title: "Artur Jutman",
          },
          {
          text: "University of Athens",
          title: "Dimitris Gizopoulos",
          },
          {
          text: "UFRGS - Brazil",
          title: "Paulo F. Butzen",
          },
          {
          text: "Universidad Nacional de Colombia",
          title: "Felipe Restrepo-Calle",
          },
          {
          text: "University of Montpellier",
          title: "Frédéric Wrobel",
          },
          {
          text: "Télécom Paris",
          title: "Lirida Naviner",
          },
          {
          text: "Gunma University",
          title: "Haruo Kobayashi",
          },
          {
          text: "LIRMM",
          title: "Patrick Girard",
          },
          {
          text: "Politecnico di Torino",
          title: "Matteo Sonza Reorda",
          },
          {
          text: "Lyon Institute of Nanotechnology",
          title: "Alberto Bosio",
          },
          {
          text: "Lund University",
          title: "Erik Larsson",
          },
          {
          text: "University of Stuttgart",
          title: "Ilia Polian",
          },
          {
          text: "Universidad de la Republica",
          title: "Julio Perez Acle",
          },
          {
          text: "Univ. Grenoble Alpes, CNRS, TIMA",
          title: "Rodrigo Possamai Bastos",
          },
          {
          text: "TIMA Laboratory",
          title: "Paolo Maistri",
          },
          {
          text: "Universidade Federal de ViÃ§osa",
          title: "José Augusto Nacif",
          },
          {
          text: "McMaster University",
          title: "Nicola Nicolici",
          },
          {
          text: "ONERA - The French Aerospace Lab",
          title: "Laurent Artola",
          },
          {
          text: "Delft University of Technology",
          title: "Mottaqiallah Taouil",
          },
          {
            text: "University of Rennes 1 - IRISA/INRIA",
            title: "Angeliki Kritikakou",
          },
          {
            text: "Inria Rennes / IRISA",
            title: "Marcello Traiola",
          },
          {
          text: "University of Stuttgart",
          title: "Hans-Joachim Wunderlich",
          },
          {
          text: "Qualcomm Technologies Inc",
          title: "Soumya Mittal",
          },
          {
          text: "TIMA Laboratory",
          title: "Salvador Mir",
          },
          {
            text: "Institute of Technology",
            title: "Xiaoqing Wen Kyushu",
          },
          {
            text: "UFSC",
            title: "Cristina Meinhardt",
          },
          {
          text: "Grenoble-INP/TIMA",
          title: "Regis Leveugle",
          },
          {
          text: "Synopsys",
          title: "Gurgen Harutyunyan",
          },
          {
          text: "Delft University of Technology",
          title: "Moritz Fieback",
          },
          {
          text: "University of Piraeus",
          title: "Mihalis Psarakis",
          },
          {
            text: "UFRGS Federal University",
            title: "Marcelo Lubaszewski",
          },
          {
            text: "Univ. Montpellier, CNRS, LIRMM",
            title: "Florence Azais",
          },
          {
            text: "IES/CNRS/UM",
            title: "Luigi Dilillo",
          },
          {
            text: "Hamburg University of Technology",
            title: "Goerschwin Fey",
          },
          {
            text: "RWTH Aachen University, Aachen",
            title: "Supriya Chakraborty",
          },
          {
            text: "Instituto de Microelectronica de Sevilla (IMSE-CNM-CSIC)",
            title: "Gildas Leger",
          },
          {
            text: "FEEC/DEEB/UNICAMP",
            title: "Leandro Manera",
          },
      ],

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
